import likeButtonView from './likeButtonComponent.html';
import './likeButtonComponent.css';

export function likeButtonComponent() {
	return {
		bindings: {
			post: '=',
		},
		controllerAs: 'vm',
		controller: likeButtonComponentCtrl,
		template: likeButtonView,
	};
}

export class likeButtonComponentCtrl {
	constructor(Api, Cfg) {
		'ngInject';
		this.Api = Api;
		this.Cfg = Cfg;
		this.hideLikesAndComments = this.Cfg.read('Features.hide_likes_and_comments') !== '0';
		this.processingLike = false;
	}

	toggleLike() {
		//prevents being able to mash on the like button causing multiple likes for one user
		if (this.processingLike) {
			return;
		}
		// use a hubs header until we update these likes endpoint to check access based
		// on the user's access to this post id, not on the "current" hub
		if (this.post.user_like_id) {
			this.Api.delete(`/posts/${this.post.id}/likes/${this.post.user_like_id}`, null);
			this.post.user_like_id = null;
			this.post.likes_count--;
		} else {
			this.processingLike = true;
			this.Api.request('POST', `/posts/${this.post.id}/likes`, null).then(response => {
				this.processingLike = false;
				this.post.user_like_id = response.headers('API-Record-Id');
				this.post.likes_count++;
			});
		}
	}
}
